module.exports = __webpack_public_path__ + "static/img/fish54.50fd001.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fish/jingdianfish/fish54.png
// module id = XRlC
// module chunks = 0